
// import moment from "moment";

// export const PostDate = (args) => {
//   const lastCommentDate = new Date(args?.LastCommentDate);

//   const calculateTimeAgo = (date) => {
//     const now = moment();
//     const past = moment(date);

//     const years = now.diff(past, 'years');
//     const months = now.diff(past, 'months');
//     const weeks = now.diff(past, 'weeks');
//     const days = now.diff(past, 'days');
//     const hours = now.diff(past, 'hours');
//     const minutes = now.diff(past, 'minutes');
//     const seconds = now.diff(past, 'seconds');

//     if (years >= 1) {
//       return `${years} year${years > 1 ? 's ago' : ' ago'}`;
//     } else if (months >= 1) {
//       return `${months} month${months > 1 ? 's ago' : ' ago'}`;
//     } else if (weeks >= 1) {
//       return `${weeks} week${weeks > 1 ? 's ago' : ' ago'}`;
//     } else if (days >= 1) {
//       return `${days} day${days > 1 ? 's ago' : ' ago'}`;
//     } else if (hours >= 1) {
//       return `${hours} hour${hours > 1 ? 's ago' : ' ago'}`;
//     } else if (minutes >= 1) {
//       return `${minutes} minute${minutes > 1 ? 's ago' : ' ago'}`;
//     } else {
//       return `Just now`;
//     }
//   };

//   return calculateTimeAgo(lastCommentDate);
// };


import moment from "moment";
import { useEffect, useState } from "react";

export const PostDate = (args) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    if (!args?.LastCommentDate) return;

    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timerId);
  }, [args?.LastCommentDate]);

  const calculateTimeAgo = (date) => {
    const now = moment(currentTime);
    const past = moment(date);

    const years = now.diff(past, "years");
    const months = now.diff(past, "months");
    const weeks = now.diff(past, "weeks");
    const days = now.diff(past, "days");
    const hours = now.diff(past, "hours");
    const minutes = now.diff(past, "minutes");

    if (years >= 1) return `${years} year${years > 1 ? "s" : ""} ago`;
    if (months >= 1) return `${months} month${months > 1 ? "s" : ""} ago`;
    if (weeks >= 1) return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
    if (days >= 1) return `${days} day${days > 1 ? "s" : ""} ago`;
    if (hours >= 1) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    if (minutes >= 1) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;

    return "Just now";
  };

  return calculateTimeAgo(args?.LastCommentDate);
};
